<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "Confirm-Order",
        "hide-footer": "",
        centered: "",
        size: "sm",
      },
      on: {
        hide: function ($event) {
          return _vm.onModalHidden(false)
        },
      },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "icon-bg edit-bg head-top-15" },
        [
          ["SOLD", "RECEIVED"].includes(_vm.type)
            ? _c("feather-icon", { attrs: { icon: "CheckIcon", size: "38" } })
            : _c("feather-icon", {
                attrs: { icon: "HelpCircleIcon", size: "38" },
              }),
        ],
        1
      ),
      _c("div", { staticClass: "text-center d-flex justify-content-center" }, [
        _c("span", { staticClass: "text-center pay-text" }, [
          _vm._v(" " + _vm._s(_vm.title) + " "),
        ]),
      ]),
      _vm.subTitle
        ? _c(
            "div",
            { staticClass: "text-center mb-1 d-flex justify-content-center" },
            [
              ["SOLD", "RECEIVED"].includes(_vm.type)
                ? _c("span", { staticClass: "text-center pay-text sm-p" }, [
                    _vm._v(_vm._s(_vm.subTitle)),
                  ])
                : _c("span", { staticClass: "text-center pay-text" }, [
                    _vm._v(_vm._s(_vm.subTitle)),
                  ]),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c(
            "b-button",
            {
              staticClass: "mb-1 mt-1 ok-w text-center",
              attrs: { variant: "primary" },
              on: {
                click: function ($event) {
                  return _vm.apiCall()
                },
              },
            },
            [_vm._v(_vm._s(_vm.buttonText))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/CancelOrder/ConfirmPop.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  components: {
    BModal: bootstrapvue["BModal"],
    BButton: bootstrapvue["BButton"]
  },
  data() {
    return {
      modalVisible: this.showPop
    };
  },
  watch: {
    showPop(newValue) {
      this.modalVisible = newValue;
    }
  },
  methods: {},
  props: {
    type: {
      type: String,
      default: ""
    },
    showPop: {
      type: Boolean,
      isRequired: false,
      default: false
    },
    onModalHidden: {
      type: Function,
      isRequired: true,
      default: () => {}
    },
    title: {
      type: String,
      isRequired: true,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      isRequired: true,
      default: ""
    },
    apiCall: {
      type: Function,
      isRequired: true,
      default: () => {}
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/CancelOrder/ConfirmPop.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
.pay-text {
  font-size: 18px;
  color: var(--black);
}[dir=ltr] .pay-text {
  padding-left: 25px;
  padding-right: 25px;
  float: left;
}[dir=rtl] .pay-text {
  padding-right: 25px;
  padding-left: 25px;
  float: right;
}
[dir] .head-top-25 {
  margin-top: -15px;
}
.sm-p {
  color: var(--primary);
  font-size: 23px;
}
[dir] .sm-p {
  margin-top: 10px;
}
.ok-w {
  min-width: 30%;
}
</style>
